@use "sass:string";
@use "breakpoint" as *;

:export {
    @each $name, $value in $camel-case-widths {
        #{string.unquote($name)}: $value;
    }
}
